import type { Doc } from "@types_def/models/delivery.types";
import type { DateTime } from "luxon";

export function customDeliveryVerifiedAtDate(date: Date) {
  return date
    .toLocaleDateString("fr", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(":", "h")
    .replace(",", " à");
}

export function customDeliveryScheduledForDate(date: DateTime) {
  return new Date(date as unknown as Date)
    .toLocaleDateString("fr", {
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(":", "h")
    .replace(",", " à");
}

/**
 * The `docs` / `validationDocs` GraphQL fields return `any` (JSON scalar).
 * They may arrive as a serialised JSON string or an already-parsed array.
 */
export function parseDocs(value: Doc[] | string | null | undefined): Doc[] {
  if (typeof value === "string") return JSON.parse(value) as Doc[];
  return Array.isArray(value) ? value : [];
}
